import { render, staticRenderFns } from "./TessLogo.vue?vue&type=template&id=e8da9a6c&"
import script from "./TessLogo.vue?vue&type=script&lang=ts&"
export * from "./TessLogo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports